import { useMutation, useQueryClient } from "@tanstack/react-query";
import { taskApi } from "../service";
import { taskKeys } from "../task.keys";
import { scheduleKeys } from "../../../schedule/api/schedule.keys";
import { rescheduleKeys } from "../../../reschedule/api/reschedule.keys";

/**
 * Delete a task, optionally the whole rest of its series.
 *
 * `forFullSeries` also removes every LATER occurrence, skipping any that is completed or already
 * started — the twin of `useDeleteAppointment`.
 *
 * The addressed task goes whatever its state; the route answers 403 to anyone but the office, so
 * call sites gate the button on `useCanDeleteWorkItems`.
 */
export function useDeleteTask() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, forFullSeries }: { id: number; forFullSeries?: boolean }) =>
      taskApi.delete(id, forFullSeries).then((r) => r.data),
    // `onSettled`, like `useDeleteAppointment`: a failed delete may still have changed the list.
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: taskKeys.lists() });
      // A deleted task must vanish from the calendar too, which is keyed under scheduleKeys.
      queryClient.invalidateQueries({ queryKey: scheduleKeys.all });
      // A flagged task that is deleted leaves the Umdisponierung count.
      queryClient.invalidateQueries({ queryKey: rescheduleKeys.count() });
    },
  });
}
